import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useStore } from 'store/useStore'
import { getPromoModuleKey } from 'sections/PromoSection/shared/utils'
import { Button, Flex, Modal, Rate, Text, TextArea } from 'components/uiKit'
import { getSharedKey } from 'utils/helpers/i18n/getKeys'
import { LKRoutesEnum } from 'shared/constants/routes'

import { ticketGradeTranslator, TicketKeys } from '../../../data'
import { TicketStatus } from '../../../types'

type TicketActionsProps = {
  canRate: boolean
  status: TicketStatus
}

const getKey = (key: string) => `${TicketKeys.ticketItemPage}.${key}`

export const TicketActions = observer(({ canRate, status }: TicketActionsProps) => {
  const { viewTicketUiStore: uiStore } = useStore()

  const navigate = useNavigate()
  const { t } = useTranslation()

  const [isCloseTicketModalOpen, setIsCloseTicketModalOpen] = useState(false)
  const [isGradeTicketModalOpen, setIsGradeTicketModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const [grade, setGrade] = useState(5)
  const [gradeComment, setGradeComment] = useState('')

  const closeTicketButtonHandler = async () => {
    setLoading(true)

    const result = await uiStore.closeTicket()

    if (result) {
      if (uiStore.selectedTicket?.canRate) {
        setIsGradeTicketModalOpen(true)
      }

      setIsCloseTicketModalOpen(false)
    }

    setLoading(false)
  }

  const gradeTicketButtonHandler = async () => {
    setLoading(true)

    const result = await uiStore.rateTicket(grade, gradeComment.trim())

    if (result) {
      navigate(LKRoutesEnum.tickets)
    }

    setLoading(false)
  }

  const cancelGradeButtonHandler = () => {
    setIsGradeTicketModalOpen(false)
    setIsCloseTicketModalOpen(false)
  }

  return (
    <Flex>
      {status !== TicketStatus.closed && (
        <Button onClick={() => setIsCloseTicketModalOpen(true)}>{t(getKey('Вопрос решен'))}</Button>
      )}

      {canRate && <Button onClick={() => setIsGradeTicketModalOpen(true)}>{t(getKey('Поставить оценку'))}</Button>}

      <Modal
        title={t(getSharedKey('Внимание'))}
        open={isCloseTicketModalOpen}
        onOk={closeTicketButtonHandler}
        onCancel={() => setIsCloseTicketModalOpen(false)}
        okText={t(getSharedKey('yes'))}
        cancelText={t(getSharedKey('no'))}
        okButtonProps={{ loading }}
      >
        <Text>{t(getKey('Если ваш вопрос решен'))}</Text>
      </Modal>

      <Modal
        open={isGradeTicketModalOpen}
        onOk={gradeTicketButtonHandler}
        onCancel={cancelGradeButtonHandler}
        okText={t(getPromoModuleKey('openPickPointForm.Подтвердить'))}
        okButtonProps={{ loading, disabled: !grade }}
      >
        <Flex vertical gap={16}>
          <Text>{t(getKey('Оцените работу поддержки'))}</Text>

          <Rate tooltips={Object(ticketGradeTranslator).values} value={grade} onChange={setGrade} />

          <TextArea
            value={gradeComment}
            onChange={(e) => setGradeComment(e.target.value)}
            maxLength={500}
            placeholder={t(getKey('Можете оставить комментарий'))}
            autoSize
          />
        </Flex>
      </Modal>
    </Flex>
  )
})
